var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterestedBy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#fff",
    width: "470px",
    height: "470px",
    viewBox: "0 0 470 470",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-511.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(511.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "to-fill",
    id: "Rectangle",
    fill: "#220BAB",
    x: 0,
    y: 0,
    width: 470,
    height: 470,
    rx: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "currentColor",
    id: "I\\u2019m-interested-by-An",
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 36,
    fontWeight: "bold",
    "line-spacing": 50,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 196
  }, "I\u2019m interested by"), /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 246
  }, "Angular, Blockchain"), /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 296
  }, "&amp; React.")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestedBy);
export default __webpack_public_path__ + "static/media/interested_by.1717285e9b0fcce1e226a48a5d1be1c9.svg";
export { ForwardRef as ReactComponent };